import PageHeader from "@/components/common/PageHeader";
import { Box } from "@mui/system";
import { FC } from "react";
import ContentCards from "./ContentCards";

const NewsAndEventsManagement: FC = () => {
   return (
      <Box sx={{
         backgroundColor: 'background.default',
         px: { xs: 2, md: 3, lg: 4 }
      }}>
         <PageHeader title="Gestor de Contenido Intitucional" description="Administra toda la información pública del sitio web  desde un solo lugar. Porfavor Selecciona el cotenido que deseas editar" />
         <ContentCards />
      </Box>);
};


export default NewsAndEventsManagement